//import {nav_width} from '../misc/utilis';

var mobile = $('nav#nav-main').clone().attr('id','nav-mobile');
mobile.appendTo('header#top_header');
mobile.addClass('container');
var logo = mobile.find('#brand_logo');
var homeBtn = '<li class="'+logo.attr('class')+'"><a href="'+logo.find('a').attr('href')+'">Home</a></li>';
logo.remove();
mobile.find('li.mobile_ico,#fakeSubHolder').remove();
mobile.find('ul').first().prepend(homeBtn);
mobile.find('ul.dropDown li').removeAttr('style');

$('#menu_opener').click(function(){
  $('body').toggleClass('mobileMenuOpened');
});
$('nav#nav-main > ul > li.products_drop').hover(function(){ 
      var dropDown = $(this).find('ul.productDropdown'),
      childH = dropDown.outerHeight(),
      marginApply = ($('header#top_header').hasClass('moved'))?30:15;
      dropDown.stop().slideDown(300);
      $('#fakeSubHolder').css({'height':childH+marginApply});
      $('#fakeSubHolder').stop().slideDown(300);
  },
  function () {
      var dropDown = $(this).find('ul.productDropdown');
      dropDown.stop().slideUp(500);  
      $('#fakeSubHolder').stop().slideUp(380);
  }
);

$('nav#nav-mobile ul li .mobile_opener').click(function(){
    if(!$(this).hasClass('opened'))  $('nav#nav-mobile ul.dropDown');
    if($(this).hasClass('fa-angle-down')) {
      $(this).removeClass('fa-angle-down').addClass('fa-angle-up');
    }
    else {
      $(this).removeClass('fa-angle-up').addClass('fa-angle-down');
    }
    $(this).toggleClass('opened').next('ul.dropDown').slideToggle(300);
});

 $(window).scroll(function(){
    var st = $(this).scrollTop();
    if(st>100) {
        $('header#top_header').addClass('moved');
       //nav_width();
    }
    else {
       $('header#top_header').removeClass('moved');
       //nav_width();
    }
 });

var lastScroll = 0;
$(window).scroll(function(){
  var st = $(this).scrollTop();
  if (st > lastScroll && st>150){
  //Down
  $('header#top_header').addClass('hidde');
  } 
  else {
    //Up
    $('header#top_header').removeClass('hidde');
  }
  lastScroll = st;
});


// WEBPACK FOOTER //
// ./scripts/misc/nav.js